import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import defaultThumbnail from '@adsk/bim360-matrix-react-assets/attachment-icon.svg';

const IssueAttachmentThumbnail = ({thumbnailUrl}) => (
  <div className="IssueAttachmentThumbnail">
    {!thumbnailUrl && (
      <SvgIcon width="24px" height="30px" className="IssueAttachmentThumbnail__icon">
        {defaultThumbnail}
      </SvgIcon>
    )}
    {thumbnailUrl && <img src={thumbnailUrl} className="IssueAttachmentThumbnail__img" />}
  </div>
);

IssueAttachmentThumbnail.displayName = 'IssueAttachmentThumbnail';

IssueAttachmentThumbnail.propTypes = {
  thumbnailUrl: PropTypes.string
};

export default IssueAttachmentThumbnail;
